var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logout_Kopie_2",
    "data-name": "logout Kopie 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logout_Kopie_2-2",
    "data-name": "logout Kopie 2",
    d: "M1273.457,4008.979a3.6,3.6,0,0,1-3.558-3.485l0-.167v-8.693a3.608,3.608,0,0,1,3.395-3.652l.163,0h3.712a3.6,3.6,0,0,1,3.56,3.484l0,.9a.76.76,0,0,1-1.514.106l-.006-.092v-.742a2.074,2.074,0,0,0-1.922-2.092l-.125,0h-3.7a2.066,2.066,0,0,0-2.038,1.973l0,.129v8.682a2.075,2.075,0,0,0,1.922,2.091l.125,0h3.709a2.058,2.058,0,0,0,2.031-1.963l0-.86a.76.76,0,0,1,1.514-.105l.006.093v.749a3.6,3.6,0,0,1-3.383,3.644l-.168,0Zm8.911-5.173a.8.8,0,0,1-.072-1.017l.063-.077.932-.954h-7.316a.782.782,0,0,1-.1-1.554l.091-.007h7.329l-.923-.941a.8.8,0,0,1-.075-1.016l.063-.077a.756.756,0,0,1,1-.087l.075.065,2.229,2.275a.785.785,0,0,1,.233.563.794.794,0,0,1-.238.566l-2.213,2.262a.751.751,0,0,1-1.075,0Z",
    transform: "translate(-1269.894 -3992.979)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.70d91daa9f0e372b615a6e060b3ff549.svg";
export { ForwardRef as ReactComponent };